import * as ReqType from '../types/ServerRequests';
import LoginServices from './LoginServices';
import Axios, { AxiosResponse } from 'axios';

/**
 * Cette classe permet la communication entre le backend et le frontend
 * Elle assure l'envois la reception des données entre le backend et frontend
 * Elle permet la creation, modification, et suppression des tags
 */
export class TagService {
    private static instance: TagService = new TagService();

    public static getInstance(): TagService {
        return this.instance;
    }

    /**
     * permet la modification et la mise à des tag
     * @param {Tag} tag
     * @returns {AxiosPromise<any>}
     */
    public updateTag(tag: ReqType.Tag) {
        const token = LoginServices.getInstance().getUserToken();
        return (
            Axios.put(
                process.env.REACT_APP_TAG_UPDATE_URL! + '&id=' + tag.id,
                tag,
                {
                    headers: { 'X-Access-Token': token }
                }
            )
        );
    }

    /**
     * retourne une liste des tags
     * @returns {Promise<Tag[]>}
     */
    public getTags(): Promise<ReqType.Tag[]> {
        const token = LoginServices.getInstance().getUserToken();
        return (
            Axios.get(
                process.env.REACT_APP_TAG_LIST_URL!,
                {
                    headers: { 'X-Access-Token': token }
                }
            ).then(
                (r: AxiosResponse<ReqType.Tag[]>) => {
                    return r.data;
                }
            )
        );
    }
}


// WEBPACK FOOTER //
// ./src/services/TagService.tsx